<template>
  <div class="panel mt-20" v-show.async="show">
    <template v-if="order.status >= 4">
      <div class="header">
        <el-button
          v-if="order.deleted == 0"
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="startInvoiceRecordFormer()"
          v-permission="Auth.orderInvoiceRecordNew"
          >开票记录</el-button
        >
      </div>
      <el-table
        v-if="!isMobile()"
        :data="records"
        style="width: 100%"
        key="records"
      >
        <el-table-column prop="amount" label="开票金额">
          <template slot-scope="scope">
            <span>￥{{ math.show(scope.row.amount) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="开票时间" width="140">
          <template slot-scope="scope">
            <span>{{ formatTime(scope.row.date) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="开票文件">
          <template slot-scope="scope">
            <span v-if="isImage(scope.row.file)">
              <auth-img
                tag="el-image"
                style="width: 60px; height: 60px"
                :src="host + scope.row.file"
                :preview-src-list="fileList"
              ></auth-img>
            </span>
            <a
              v-else-if="scope.row.file.length > 0"
              :href="host + scope.row.file"
              target="_blank"
              >查看文件</a
            >
          </template>
        </el-table-column>
        <el-table-column prop="user" label="发票抬头" width="160">
          <template slot-scope="scope">
            <span v-if="scope.row.customer_invoice_id > 0">
              {{ scope.row.customer_invoice.title }}
            </span>
          </template>
        </el-table-column>

        <el-table-column prop="user" label="操作人" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.user.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140">
          <template slot-scope="scope">
            <div class="flex-row-between">
              <el-button
                type="danger"
                size="mini"
                plain
                @click="deleteInvoiceRecord(scope.$index)"
                v-permission="Auth.orderInvoiceRecordDelete"
                >删除</el-button
              >
              <el-button
                type="primary"
                size="mini"
                plain
                @click="startInvoiceRecordFormer(scope.row, scope.$index)"
                v-permission="Auth.orderInvoiceRecordEdit"
                >修改</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <ul v-else>
        <li v-for="item in records">
          <div v-if="item.customer_invoice_id > 0">
            {{ item.customer_invoice.title }}
          </div>
          <div class="font-12 flex-row-between">
            <span>金额：￥{{ math.show(item.amount) }}</span>
            <span class="text-gray">{{ formatTime(item.date) }}</span>
          </div>
        </li>
      </ul>
    </template>
    <div v-else class="text-gray">订单审批后，可添加开票记录。</div>

    <invoice-record
      :show.sync="invoiceRecordFormerVisbile"
      :model="invoiceRecordForm"
      :customerOrderID="order.customer_id"
      @created="createdInvoiceRecord"
      @updated="updatedInvoiceRecord"
    ></invoice-record>
  </div>
</template>

<script>
import {
  customerCollectionList,
  invoiceRecordList,
  deleteInvoiceRecord,
} from '../../service/getData'
import { formatTime, isImage } from '@/util/index'
import { clone } from '@/util'
import InvoiceRecord from '@/components/invoice_record'
import math from '../../util/math'
import { host } from '../../config/env'
import { isMobile } from '../../util'

export default {
  components: { InvoiceRecord },
  props: {
    customerOrderID: {
      type: Number,
      default: 0,
    },
    order: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      math,
      isMobile,
      isImage,
      host,
      formatTime,
      records: [],
      invoiceRecordFormerVisbile: false,
      invoiceRecordForm: {},
      editRecordIndex: 0,
      number: '',
      date: null,
      pageSize: 16,
      currentPage: 1,
      fileList: [],
    }
  },
  created() {
    if (this.show) {
      this.requestInvoiceRecords()
    }
  },
  watch: {
    show() {
      if (this.show && this.records.length == 0) {
        this.requestInvoiceRecords()
      }
    },
  },
  methods: {
    refresh() {
      this.clearFilter()
    },
    async requestInvoiceRecords() {
      let data = {
        customer_order_id: this.customerOrderID,
      }

      let res = await invoiceRecordList(data)

      if (res.code == 0) {
        this.records = res.data.list
        this.reloadFileList()
      }
    },
    reloadFileList() {
      this.records.map((i) => {
        if (i.file && i.file.length > 0 && isImage(i.file)) {
          this.fileList.push(host + i.file)
        }
      })
    },
    startInvoiceRecordFormer(record, index) {
      if (record) {
        this.invoiceRecordForm = clone(record)
      } else {
        this.invoiceRecordForm = {
          customer_order_id: this.customerOrderID,
          amount: null,
          customer_invoice_id: null,
          date: new Date(),
          file: null,
        }
      }
      this.invoiceRecordFormerVisbile = true
    },
    deleteInvoiceRecord(index) {
      let that = this
      let ir = this.records[index]
      this.$confirm('是否确认删除卡票记录', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteInvoiceRecord(ir.id).then((res) => {
          if (res.code == 0) {
            that.records.splice(index, 1)
            that.reloadFileList()
          }
        })
      })
    },
    createdInvoiceRecord(record) {
      this.records.unshift(record)
      this.reloadFileList()
    },
    updatedInvoiceRecord(record) {
      this.records.splice(this.editRecordIndex, 1, record)
      this.reloadFileList()
    },
  },
}
</script>

<style scoped>
.el-date-editor .el-range-input {
  width: 100px !important;
}
</style>